var exports = {
  "IW": "VoiceParticipantAvatarList.module__stackAvatar___RW1GWj",
  "K_": "VoiceParticipantAvatarList.module__stackAvatarSpeaking___RW1GWj",
  "Eh": "VoiceParticipantAvatarList.module__wrapContainer___RW1GWj",
  "EN": "VoiceParticipantAvatarList.module__wrapAvatarSlot___RW1GWj",
  "FU": "VoiceParticipantAvatarList.module__wrapAvatarSlotAnimated___RW1GWj",
  "ee": "VoiceParticipantAvatarList.module__wrapAvatar___RW1GWj",
  "lE": "VoiceParticipantAvatarList.module__wrapAvatarAnimated___RW1GWj",
  "i1": "VoiceParticipantAvatarList.module__remainingCount___RW1GWj",
  "jC": "VoiceParticipantAvatarList.module__popoutContainer___RW1GWj",
  "qE": "VoiceParticipantAvatarList.module__popoutList___RW1GWj",
  "Az": "VoiceParticipantAvatarList.module__popoutRow___RW1GWj",
  "ps": "VoiceParticipantAvatarList.module__popoutRowAvatar___RW1GWj",
  "fU": "VoiceParticipantAvatarList.module__popoutRowName___RW1GWj",
};

module.exports = exports;
